import { ReactNode } from "react";
import { LottiePlayerProps } from "@trailhead/lottie";

export enum ExpertSupportButtonType {
  CALL = "call",
  CHAT = "chat",
}

export interface ExpertSupport {
  title: string;
  subtext?: string;
  primaryButtonText?: string;
  primaryButtonType?: ExpertSupportButtonType;
  secondaryButtonText?: string;
  secondaryButtonType?: ExpertSupportButtonType;
  supportNumber?: string;
  image?: ReactNode;
  lottie?: LottiePlayerProps;
}
